var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59.69px",
    height: "70.53px",
    viewBox: "0 0 59.69 70.53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-269.500000, -1483.100000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.03,1513.95 C274.158934,1507.39568 276.826137,1501.14712 281.47,1496.52 L281.48,1496.53 C285.092533,1492.91201 289.708725,1490.46282 294.73,1489.5 L294.73,1483.1 L304.07,1483.1 L304.07,1489.52 C315.867984,1491.76247 324.494933,1501.94394 324.77,1513.95 L324.78,1513.95 L324.78,1526.02 L315.44,1526.02 L315.44,1514.45 C315.418099,1505.60109 308.258852,1498.42845 299.41,1498.39 L299.41,1498.41 C295.160009,1498.40489 291.082965,1500.09257 288.08,1503.1 L288.08,1503.12 C285.063058,1506.11904 283.364607,1510.19604 283.36,1514.45 L283.36,1530.48 L297.17,1530.48 L297.17,1539.82 L269.56,1539.82 L269.56,1530.48 L274.02,1530.48 L274.02,1513.95 L274.03,1513.95 L274.03,1513.95 Z M294.73,1544.29 L304.07,1544.29 L304.07,1553.63 L294.73,1553.63 L294.73,1544.29 Z",
    id: "Path_130",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_131",
    fill: "#BEB0FF",
    points: "301.64 1530.48 329.25 1530.48 329.25 1539.82 301.64 1539.82"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.91174880507c562484af67e8bc7ca837.svg";
export { ForwardRef as ReactComponent };